<template>
	<div class="wrap" ref="activeModal">
		<div class="returnIcon" @click.stop="$router.go(-1)"><img src="~assets/images/makeImages/return.png" alt="" /></div>
		<span ref="bag" class="bag" @click.stop="jump" draggable="true"
			@touchstart="bagTouchStart($event)" @touchmove="bagTouchMove($event)" @touchend="bagTouchEnd($event)"
			:style="{zIndex:bagZindex,left:bagLeft,top:bagTop}">
			<img src="~assets/images/makeImages/bags.png" alt />
		</span>
		<div class="content" :style="{backgroundColor: '#' + atBgColor}">
			<div class="contentBg">
				<img :src="tBgImage" alt="">
				<div class="gradientMask"></div>
			</div>
			<div class="main">
				<div class="assemblyBgColor mainTop" v-if="subscribeModular">
					<img :src="gameInf.iconUrl" alt />
					<p class="tit"><em>{{gameInf.displayName}}</em></p>
					<p>{{appointmentInf.onlineDesc}}</p>
					<p>已有{{appointmentInf.count}}人预约</p>
				</div>
				<template v-for="item in choosecomponent">
					<LuckDraw ref="luckDraw" v-if="item.type == 'wheel'" :key="item.type" :luckDrawId="item.awardIdPointer" @showMaskTxt="showMaskTxt" @showDrawResults="showDrawResults"></LuckDraw>
				</template>
				<ActivityRules v-if="activityRulesArr.length > 0" :activityRulesArr="activityRulesArr"></ActivityRules>
				<template v-if="subscribeModular">
					<Welfare ref="welfare" @setAppointmentInf="setAppointmentInf"></Welfare>
					<Introduce v-if="appointmentInf.gameId" :gameId="appointmentInf.gameId" @setGameInf="setGameInf"></Introduce>
				</template>
			</div>
		</div>
		<div class="shareWrap" :style="{backgroundImage: gradientStr}">
			<div class="shareBtn" @click.stop="showMask = true, maskType = 7">
				<img src="~assets/images/makeImages/share.png" alt="">
				<span>分享</span>
			</div>
			<van-button v-if="!isDownload" class="makeBtn" :class="appointmentInf.subscribeStatus == 1 && !online ? 'noMakeBtn' : ''" :loading="receiveLoading" plain type="primary" @click.stop="subscribeClickBtn">{{subscribeTxt}}</van-button>
			<!-- <div v-if="!isDownload" class="makeBtn" :class="conditionType == 1 && !online ? 'noMakeBtn' : ''" @click.stop="subscribeClickBtn">{{subscribeTxt}}</div> -->
			<div v-else class="makeBtn downloadProgress" @click.stop="downloadGameProcess"><i>{{downloadTxt}}</i><span class="progress" :style="{width: speed}"></span></div>
		</div>
		<div class="mask" v-show="showMask">
			<div class="maskBox" :class="maskType === 5 ? 'gradient' : maskType === 0 ? 'phoneTop' : ''" v-show="maskType < 7">
				<div class="closeMask" v-show="maskType != 2 && maskType != 3" @click.stop="closeMaskFun"><img src="~assets/images/makeImages/close.png" alt=""></div>
				<div class="phoneMain" v-if="maskType === 0">
					<div class="phonBox">
						<div class="bigTit">手机号预约提醒</div>
						<p>留下正确的手机号，能够提高您的预约成功率哦~</p>
						<p class="pUnm"><span>1、</span>游戏上线，将通过<i style="color: red;">免费短信</i>提醒下载游戏和领取福利哦！</p>
						<p class="pUnm"><span>2、</span>填写的手机号码仅用于预约短信提醒。</p>
						<div class="phoneInput">
							<input type="number" ref="phoneInput" v-model="phone" placeholder="请输入你的手机号码" />
							<img src="~assets/images/makeImages/delete.png" alt="" @click.stop="emptyPhone" />
						</div>
					</div>
					<van-button class="phoneBtn" :loading="subscribeLoading" plain color="#FF9500" type="primary" @click.stop="postSubscribe">马上预约</van-button>
				</div>
				<div class="sucessMain makeSucessMain" v-if="maskType === 1">
					<img src="~assets/images/makeImages/sucess.png" alt="">
					<div class="bigTit">预约成功</div>
					<div class="ylTxt">赶快去抽奖吧！</div>
					<p>游戏上线后将通过免费短信提醒，记得回来下载哦！</p>
					<div class="clickBtn" @click.stop="scrollLuckDraw">去抽奖</div>
				</div>
				<div class="sucessMain" v-show="maskType === 2">
					<div class="bigTit">{{txtTitle}}</div>
					<p>{{txtContent}}</p>
					<div class="clickBtn" @click.stop="closeMaskFun">{{txtBtn}}</div>
				</div>
				<div class="sucessMain" v-show="maskType === 3">
					<div class="bigTit">未中奖</div>
					<p>好遗憾~<br />距离大奖只差一点点~</p>
					<div class="clickBtn">知道了</div>
				</div>
				<div class="sucessMain copyMain" v-if="maskType === 4">
					<div class="bigTit">领取成功</div>
					<p>预约礼包发放成功，请在背包内查看</p>
					<!-- <div class="copyBox">{{giftCode}}<span @click.stop="clickcCopy">复制</span></div> -->
					<div class="clickBtn" @click.stop="copyUse">复制并使用</div>
				</div>
				<div class="prizeMain" v-show="maskType === 5">
					<div class="prizeTit"><img src="~assets/images/makeImages/prize.png" alt="" /></div>
					<p>奖品可在“我的背包”中查看。</p>
					<div class="prizeBox"><img :src="prizeObj.icon" alt="" /><p>{{prizeObj.shortName == '现金' || prizeObj.shortName == '金币' ? prizeObj.shortName == '现金' ? prizeObj.awardQuantity / 100 + '元': prizeObj.awardQuantity : ''}}{{prizeObj.shortName}}{{prizeObj.awardQuantity > 1 && prizeObj.shortName != '现金' && prizeObj.shortName != '金币' ? prizeObj.awardQuantity : ''}}</p></div>
					<div class="prizeBtn"><span @click.stop="jump">查看</span><span @click.stop="maskType = 7">分享</span></div>
				</div>
				<div class="sucessMain" v-if="maskType === 6">
					<div class="bigTit">提示</div>
					<p>是否确认取消预约？</p>
					<div class="btnBox">
						<van-button class="btnSpan" plain color="#FF9500" type="primary" @click.stop="closeMaskFun">取消</van-button>
						<van-button class="btnSpan" :loading="cancelSubscribeLoading" plain color="#FF9500" type="primary" @click.stop="postCancelSubscribe">确定</van-button>
					</div>
				</div>
			</div>
			<div class="shareBox" v-if="maskType === 7">
				<p>分享到</p>
				<div class="shareCon">
					<div class="shareItem" @click.stop="shareWeb(0x1)">
						<img src="~assets/images/makeImages/wechat.png" alt="">
						<i>微信</i>
					</div>
					<div class="shareItem" @click.stop="shareWeb(0x2)">
						<img src="~assets/images/makeImages/wechatMt.png" alt="">
						<i>朋友圈</i>
					</div>
					<div class="shareItem" @click.stop="shareWeb(0x3)">
						<img src="~assets/images/makeImages/qq.png" alt="">
						<i>QQ</i>
					</div>
					<div class="shareItem" @click.stop="shareWeb(0x4)">
						<img src="~assets/images/makeImages/qqzone.png" alt="">
						<i>QQ空间</i>
					</div>
				</div>
				<div class="closeShare" @click.stop="closeMaskFun">取消</div>
			</div>
		</div>
		<div class="maskLoading" v-show="maskLoading">
			<img src="~assets/images/load.svg" alt />
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import config from "@/../config";
import active from '@/utils/axios/index'
import primaryApi from '@/utils/primaryApi'
import qs from 'qs'
import LuckDraw from "components/makeModal/luckDraw"; //预约抽奖模块
import ActivityRules from "components/makeModal/activityRules"; //活动规则模块
import Welfare from "components/makeModal/welfare"; //预约福利
import Introduce from "components/makeModal/introduce"; //游戏介绍
import { Toast, Button, Dialog } from 'vant';
Vue.use(Toast);
Vue.use(Button);
Vue.use(Dialog);
export default {
	name: 'makeAppointment',
	data() {
		return {
			showMask: false, //弹窗遮罩
			maskType: 99, //弹窗类型
			maskLoading: true, //页面加载loading
			atBgColor: '', //页面背景颜色
			gradientStr: '', //渐变
			tBgImage: '', //页面头部的背景图片
			mainPaddingTop: '2.6rem',
			bagZindex: 100,//背包的层级样式
			bagTop: '60%',//背包距离左边的位置
			bagLeft: '-0.1rem',//背包距离头部的位置
			bagwidth: '',//背包的宽度
			//背包移动时的变量
			moveflag: false, //判断是否可以移动  
			offsetleft: 0, //背包距离左边的距离
			offsettop: 0, //背包距离上面的距离
			initleft: 0, //鼠标点击之后按下的点到左边的距离
			inittop: 0, //鼠标点击之后按下的点到上边的距离
			activeModalwidth: '',//整个页面的宽度
			// pid:'',//首页获取活动的id
			choosecomponent: [], //模块数组
			activityRulesArr: [], //活动规则数组
			gameInf: '', //游戏介绍子组件回传的游戏信息
			appointmentInf: '', //预约福利子组件回传预约信息
			txtTitle: '', //共用文字弹窗标题
			txtContent: '', //共用文字弹窗内容
			txtBtn: '', //共用文字弹窗按钮文字
			prizeObj: '', //获得奖品
			conditionType: 0, //预约流程到哪一步,0未预约、1已预约、2已分享、3已下载、4安装游戏、5开始游戏
			phone: '', //预约手机号
			subscribeTxt: '', //底部按钮文字
			subscribeLoading: false, //立即预约按钮状态
			online: false, //活动是否上线
			cancelSubscribeLoading: false, //取消预约弹窗按钮状态
			status: null, //下载的状态 1.暂停, 2.成功, 3.失败,
			speed: '0%', //下载进度%
			progress: 0, //下载进度
			isDownload: false, //是否正在下载游戏
			downloadTxt: '', //下载状态文字
			awardId: '', //预约奖励id，为空表示此游戏没有设置预约奖励
			subscribeAwardStatus: 0, //是否已领取预约奖励
			receiveLoading: false,
			giftbagId: '', //礼包码的背包ID
			giftCode: '', //礼包码
			subscribeModular: false, //是否有预约模块
			isInstall: false, //是否安装中
			maskScroll: false, //公共弹窗的按钮文字为去抽奖，关闭弹窗滑动到抽奖
		}
	},
	computed: {
		...mapState([
		  "uuid",
		  "activityStatus",
		  "activityId",
		  "propList",
		  "cashcount",
		  "goldcount",
		  "activeBagMap",
		  "firstentry",
		  "freeact",
		  "guide",
		  "userName"
		])
	},
	components: {
		LuckDraw,
		ActivityRules,
		Welfare,
		Introduce
	},
	created() {
		this.$store.commit({
			type:'setactivityId',
			activityId: this.$route.query.id
		});
	},
	mounted() {
		this.getuuid();
		this.entry();
		this.getbag();
		/* 233小游戏内/外部下载状态的回调 */
		//pkg:包名，gid:游戏id，status:下载的状态 1.暂停, 2.成功, 3.失败
		window['downloadStatus'] = (pkg, gid, status) => {
			this.status = status;
			if (status == 2) {
				this.isDownload = false;
				primaryApi.installApk(pkg); //安装
				this.subscribeTxt = '安装中...';
				this.isInstall = true;
				this.$toast('下载完成');
				if (this.gameInf.installEnvStatus == 'VIRTUAL') { //233内部
					let installTimer = setInterval(_ => {
						if (primaryApi.isGameInstall(pkg)) { //内部是否安装了此游戏
							this.subscribeTxt = '开始游戏';
							this.isInstall = false;
							clearInterval(installTimer);
						}
					}, 20000);
				} else if (this.gameInf.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
					let installTimer = setInterval(_ => {
						if (primaryApi.isInstallOuterApp(pkg)) { //外部是否安装了此游戏
							this.subscribeTxt = '开始游戏';
							this.isInstall = false;
							clearInterval(installTimer);
						}
					}, 20000);
				}
			} else if (status == 1) {
				this.downloadTxt = '继续下载';
			} else if (status == 3) {
				this.downloadTxt = '下载失败';
			}
		};
		/* 233小游戏内/外部下载进度的回调 */
		window['downloadProgress'] = (pkg, gid, progress) => {
			this.progress = progress;
			const num = this.progress * 100;
			this.speed = num.toFixed(2) + '%';
			this.downloadTxt = '下载中：' + this.speed;
		};
	},
	methods:{
		//获取uuid
		getuuid() {
			if(primaryApi.isSource == 'sg'){
				var userInfo = JSON.parse(primaryApi.getUserInfo());
			}else{
				var userInfo = {
					uuid: '06631a0c48cc43a397e2f7c87b33224b', //d060e43baafe410fbef61f19e8ab6e18
					onlyId: '',
					userName: '测试用户名'
				}
			}
			if (!userInfo) {
				Dialog.alert({
					title: '提示',
					message: '请前去登陆233账号^ - ^',
				});
			} else {
				var uuid = userInfo.uuid;
				var onlyId = userInfo.onlyId;
				var userName = userInfo.userName;
				this.$store.commit({
					type: "setuuid",
					uuid
				});
				this.$store.commit({
					type: "setonlyid",
					onlyId
				});
				this.$store.commit({
					type: "setuserName",
					userName
				});
			}
		},
		//页面初始化渲染
		entry() {
			active.entry(config.API_HOST + "/apiserv/api/activity/entry",qs.stringify({ 
				id: this.$route.query.id
			})).then((res) => {
				this.maskLoading = false;
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				document.title = res.data.activityClient.productName; //活动题目
				this.atBgColor = res.data.activityClient.backendRGB; //背景颜色
				this.tBgImage = res.data.activityClient.topImage; //背景图片
				this.activityRulesArr = res.data.description; //活动规则
				let sColor = this.atBgColor.toLowerCase();
				let sColorChange = [];
				for(var i = 0; i < 6; i += 2){
					sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
				}
				this.gradientStr = 'linear-gradient(180deg, rgba(' + sColorChange.join(',') + ', 0), ' + 'rgba(' + sColorChange.join(',') + ', 1) 80%)'; //悬浮按钮渐变
				//活动状态进行储存
				this.$store.commit({
					type: "setactivityStatus", 
					activityStatus: res.data.activityServer.activityStatus
				});
				res.data.contentShow.forEach( item => {
					let strArr = item.split('_');
					this.choosecomponent.push({
						type: strArr[0],
						awardIdPointer: strArr[1]
					});
					if(strArr[0] == 'subscribe'){ //预约模块
						this.subscribeModular = true;
						this.$nextTick(_ => {
							this.$refs.welfare.subscribeInfo(strArr[1]);
						});
					}
				});
			}).catch((error) => {
				this.maskLoading = false;
				this.$toast('网络不稳定，请稍后');
			});
		},
		//获取背包的数据
		getbag() {
			this.$nextTick(() => {
				active.getPropInfo(config.API_HOST + "/apiserv/api/activity/getPropInfo",qs.stringify({uuid: this.uuid, propType:7})).then((res) => {
					if (res.return_code == 200) {
						this.$store.commit({
							type: "setpropList",
							propList: res.data.propList
						});
						this.$store.commit({
							type: "setcashcount",
							cashcount: res.data.cashCount
						});
						this.$store.commit({
							type: "setgoldcount",
							goldcount: res.data.goldCount
						});
						this.activeBag();
						if(this.giftbagId != '') { //表示此次请求背包是为拿到礼包码
							this.clickcCopy(res.data.propList);
						}
					} else {
						this.$toast(res.return_msg);
						if(this.giftbagId != '') { //表示此次请求背包是为拿到礼包码
							this.$toast('复制失败');
						}
					}
				}).catch(() => {
					var propList = []; //道具背包
					var cashcount = 0; //现金
					var goldcount = 0; //金币
					var activeBagMap = {};
					this.$store.commit({
						type: "setpropList",
						propList: propList
					});
					this.$store.commit({
						type: "setactivebagmap",
						activeBagMap: activeBagMap
					});
					this.$store.commit({
						type: "setcashcount",
						cashcount
					});
					this.$store.commit({
						type: "setgoldcount",
						goldcount
					});
					if(this.giftbagId != '') { //表示此次请求背包是为拿到礼包码
						this.$toast('复制失败');
					}
				})
			});
		},
		//将背包转换为map
		activeBag() {
			var map = {};
			var dest = [];
			for (var a of this.propList) {
				if (!map[a.propId]) {
					dest.push({
						propId: a.propId,
						propNum: a.propNum,
						propName: a.propName
					});
					map[a.propId] = a;
				} else {
					for (var b of dest) {
						if (b.propId == a.propId) {
							b.propNum += a.propNum;
							map[a.propId].propNum = b.propNum;
							break;
						}
					}
				}
			}
			this.$store.commit({
				type: "setactivebagmap",
				activeBagMap: map
			});
		},
		// 背包跳转
		jump() {
			window.location.href = location.origin + "/bag/";
			this.$tea("event_activemodal_gobag", {
				activityId: this.activityId,
				guide: this.guide ? this.guide : false
			}); //数据埋点
		},
		//背包触摸开始
		bagTouchStart(e) {
			this.offsetleft = this.$refs['bag'].offsetLeft;
			this.offsettop = this.$refs['bag'].offsetTop;
			this.initleft = e.touches[0].clientX;
			this.inittop = e.touches[0].clientY;
			this.moveflag = true;
			this.bagwidth = this.$refs['bag'].offsetWidth;
			this.activeModalwidth = this.$refs['activeModal'].offsetWidth;
		},
		//背包触摸点改变
		bagTouchMove(e) {
			e.preventDefault();
			this.bagZindex = 150
			var moveX = e.touches[0].clientX - this.initleft;
			var moveY = e.touches[0].clientY - this.inittop - 40;
			var bagheight = this.$refs['bag'].offsetHeight
			var activeModalheight = this.$refs['activeModal'].offsetHeight
			if (this.moveflag) {
				var disX = moveX + this.offsetleft;
				var disY = this.inittop + moveY;
				if (disX <= 0) {
					disX = -10;
				} else if (this.bagwidth + disX > this.activeModalwidth) {
					disX = this.activeModalwidth - this.bagwidth + 10;
				}
				if (disY <= 40) {
					disY = 20;
				} else if (bagheight + disY > activeModalheight) {
					disY = activeModalheight - bagheight - 20;
				}
				this.bagLeft = disX / 100 + "rem"
				this.bagTop = disY / 100 + "rem"
			}
		},
		//背包触摸结束
		bagTouchEnd() {
			if (this.$refs['bag'].offsetLeft + this.bagwidth / 2 < this.activeModalwidth / 2) {
				this.bagLeft = "-0.1rem"
			} else {
				this.bagLeft = (this.activeModalwidth - this.bagwidth) / 100 + 0.1 + "rem"
			}
			this.moveflag = false;
		},
		//接收子组件预约信息
		setAppointmentInf(inf) {
			this.appointmentInf = inf;
			this.online = inf.online;//活动是否上线
			this.subscribeAwardStatus = inf.subscribeAwardStatus;//是否已领取预约奖励
			this.awardId = inf.awardId; //预约奖励id，为空表示此游戏没有设置预约奖励
			if (this.online) { //活动是否上线
				if (this.appointmentInf.subscribeStatus == 1 && this.awardId != '' && this.subscribeAwardStatus == 0) { //活动已上线，已预约，有配置预约奖励，未领取预约奖励，按钮显示 '领取预约奖励'
					this.subscribeTxt = '领取预约奖励';
				} else {
					this.subscribeTxt = '开始游戏';
				}
			} else {
				if (this.appointmentInf.subscribeStatus == 0) { //未预约
					this.subscribeTxt = '立即预约';
				} else { //已预约，可取消预约
					this.subscribeTxt = '已预约';
				}
			}
		},
		//接收子组件游戏信息
		setGameInf(inf) {
			this.gameInf = inf;
		},
		//显示共用文字弹窗
		showMaskTxt(txtTitle, txtContent, txtBtn) {
			this.txtTitle = txtTitle;
			this.txtContent = txtContent;
			this.txtBtn = txtBtn;
			this.showMask = true;
			this.maskType = 2;
			if (txtBtn == '去抽奖') {
				this.maskScroll = true;
			}
		},
		//关闭弹窗
		closeMaskFun() {
			this.showMask = false;
			this.phone = '';
			this.maskType = 99;
			if (this.maskScroll) {
				this.$refs.luckDraw[0].$refs.luckRef.scrollIntoView({block: "start", duration: 2000, behavior: "smooth"});
				this.maskScroll = false;
			}
		},
		//根据抽奖结果显示弹窗
		showDrawResults(award) {
			this.showMask = true;
			if(award.shortName == '谢谢参与'){
				this.maskType = 3;
			} else {
				this.maskType = 5;
				this.prizeObj = award;
			}
		},
		//移动到抽奖模块
		scrollLuckDraw() {
			this.$refs.luckDraw[0].$refs.luckRef.scrollIntoView({block: "start", duration: 2000, behavior: "smooth"});
			this.showMask = false;
			this.phone = '';
			this.maskType = 99;
		},
		//点击按钮
		subscribeClickBtn() {
			if (this.online) { //活动是否上线
				if (this.appointmentInf.subscribeStatus == 1 && this.awardId != '' && this.subscribeAwardStatus == 0) { //活动已上线，已预约，有配置预约奖励，未领取预约奖励，按钮显示 '领取预约奖励'
					this.postAward(); //领取预约奖励
				} else {
					//唤起或下载游戏，此处还应判断内部游戏，外部游戏
					let packageName = this.gameInf.packageName;
					if (this.gameInf.installEnvStatus == 'VIRTUAL') { //233内部
						if (primaryApi.isDownloaded(packageName)) { //是否下载此游戏
							if (primaryApi.isGameInstall(packageName)) { //内部是否安装了此游戏
								primaryApi.playGame(this.gameInf); //唤起内部游戏
								this.conditionType = 5;
								this.postConditionAward();
								this.isInstall = false;
								this.subscribeTxt = '开始游戏';
							} else {
								if (this.isInstall) { //安装中
									this.$toast('安装中请稍候');
								} else {
									primaryApi.installApk(pkg); //安装
									this.isInstall = true;
									this.subscribeTxt = '安装中...';
									let installTimer = setInterval(_ => {
										if (primaryApi.isGameInstall(packageName)) { //内部是否安装了此游戏
											this.subscribeTxt = '开始游戏';
											this.isInstall = false;
											clearInterval(installTimer);
										}
									}, 20000);
								}
							}
						} else {
							primaryApi.downloadGame(this.gameInf, this.progress); //下载游戏
							this.isDownload = true;
							this.downloadTxt = '请求中...';
						}	
					} else if (this.gameInf.installEnvStatus == 'ANDROID_SYSTEM') { //安卓外部
						if (primaryApi.isDownloaded(packageName)) { //是否下载此游戏
							if (primaryApi.isInstallOuterApp(packageName)) { //外部是否安装了此游戏
								primaryApi.openOuterAppByPackage(packageName); //唤起外部游戏
								this.conditionType = 5;
								this.postConditionAward();
							} else {
								if (this.isInstall) { //安装中
									this.$toast('安装中请稍候');
								} else {
									primaryApi.installApk(pkg); //安装
									this.isInstall = true;
									this.subscribeTxt = '安装中...';
									let installTimer = setInterval(_ => {
										if (primaryApi.isInstallOuterApp(packageName)) { //外部是否安装了此游戏
											this.subscribeTxt = '开始游戏';
											this.isInstall = false;
											clearInterval(installTimer);
										}
									}, 20000);
								}
							}
						} else {
							primaryApi.downloadGame(this.gameInf, this.progress); //下载游戏
							this.isDownload = true;
							this.downloadTxt = '请求中...';
						}
					}
				}
			} else {
				if (this.appointmentInf.subscribeStatus == 0) { //未预约，开始预约流程
					this.showMask = true;
					this.maskType = 0;
					this.$nextTick(function () {
						this.$refs.phoneInput.focus();
					});
				} else { //已预约，取消预约
					this.showMask = true;
					this.maskType = 6;
				}
			}
		},
		//清空输入手机号
		emptyPhone() {
			this.phone = '';
			this.$nextTick(function () {
				this.$refs.phoneInput.focus();
			});
		},
		//预约
		postSubscribe() {
			if(!(/^1[3456789]\d{9}$/.test(this.phone))){ 
				this.$toast('请输入正确的手机号');
				return false; 
			}
			this.subscribeLoading = true;
			active.subscribe(config.API_HOST + "/apiserv/api/activity/subscribe/subscribe",qs.stringify({
				subscribeIdPointer: this.appointmentInf.subscribeIdPointer,
				uuid: this.uuid,
				phone: this.phone,
				activityId:  this.activityId,
				packageName: this.gameInf.packageName
			})).then((res) => {
				this.subscribeLoading = false;
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				this.appointmentInf.subscribeStatus = 1;
				this.appointmentInf.count = this.appointmentInf.count + 1;
				this.maskType = 1;
				this.subscribeTxt = '已预约';
				this.conditionType = 1;
				this.postConditionAward();
			}).catch((error) => {
				this.subscribeLoading = false;
				this.$toast('网络不稳定，请稍后');
			});
		},
		//发放预约条件奖励(道具抽奖券+1)
		postConditionAward() {
			let subscribeId = '';
			let subscribeConditionList = this.appointmentInf.subscribeConditionList;
			let caIndex;
			for (let i = 0; i < subscribeConditionList.length; i++) {
				if(this.conditionType == subscribeConditionList[i].conditionType && subscribeConditionList[i].status == 0){ //未发放此conditionType对应奖励，奖励只发放一次
					subscribeId = subscribeConditionList[i].subscribeId;
					caIndex = i;
					break;
				}
			}
			if (subscribeId == '') {
				console.log('已发放');
				if (this.conditionType == 2) {
					setTimeout(_ => {
						this.$toast('分享成功');
					}, 5000);
				}
				return;
			}
			if (this.conditionType == 2) {
				setTimeout(_ => {
					this.showMaskTxt('分享成功', '分享成功，快去抽奖吧！', '去抽奖');
				}, 5000);
			}
			active.conditionAward(config.API_HOST + "/apiserv/api/activity/subscribe/conditionAward",qs.stringify({
				subscribeIdPointer: this.appointmentInf.subscribeIdPointer,
				uuid: this.uuid,
				activityId:  this.activityId,
				subscribeId: subscribeId
			})).then((res) => {
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				//抽奖次数+1
				this.$refs.luckDraw[0].addQuantityOwned();
				this.$toast('抽奖次数+1');
				this.appointmentInf.subscribeConditionList[caIndex].status = 1;
			}).catch((error) => {
				this.$toast('网络不稳定，请稍后');
			});
		},
		//取消预约
		postCancelSubscribe() {
			this.cancelSubscribeLoading = true;
			active.cancelSubscribe(config.API_HOST + "/apiserv/api/activity/subscribe/cancelSubscribe",qs.stringify({
				subscribeIdPointer: this.appointmentInf.subscribeIdPointer,
				uuid: this.uuid,
				activityId:  this.activityId
			})).then((res) => {
				this.cancelSubscribeLoading = false;
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				this.appointmentInf.subscribeStatus = 0;
				this.appointmentInf.count = this.appointmentInf.count - 1;
				this.subscribeTxt = '预约';
				this.showMask = false;
				this.maskType = 99;
				this.$toast('已取消预约');
			}).catch((error) => {
				this.cancelSubscribeLoading = false;
				this.$toast('网络不稳定，请稍后');
			});
		},
		//领取预约奖励
		postAward() {
			this.receiveLoading = true;
			active.award(config.API_HOST + "/apiserv/api/activity/subscribe/award",qs.stringify({
				subscribeIdPointer: this.appointmentInf.subscribeIdPointer,
				uuid: this.uuid,
				activityId:  this.activityId
			})).then((res) => {
				this.receiveLoading = false;
				if (res.return_code != 200) {
					this.subscribeAwardStatus = 1; //请求失败，设为1逻辑上才能走到开始游戏
					this.$toast('预约礼包发放失败，请联系客服补发');
					return;
				}
				this.subscribeAwardStatus = 1;
				this.showMask = true;
				this.maskType = 4;
				this.subscribeTxt = '开始游戏';
				for(let i = 0; i < res.data.propList.length; i++) {
					if(res.data.propList[i].propType == '20') { //礼包码	类型20
						this.giftbagId = res.data.propList[i].propId;
						break;
					}
				}
			}).catch((error) => {
				this.receiveLoading = false;
				this.subscribeAwardStatus = 1; //请求失败，设为1逻辑上才能走到开始游戏
				this.$toast('预约礼包发放失败，请联系客服补发');
			});
		},
		//暂停/ 继续下载/ 重新下载游戏
		downloadGameProcess() {
			if(this.status == 1 || this.status == 3) {
				primaryApi.downloadGame(this.gameInf, this.progress) //继续下载游戏
				this.status = null; //初始状态
				this.downloadTxt = '请求中...';
			} else { //暂停
				primaryApi.downloadStop(this.gameInf);
			}
		},
		//分享
		shareWeb(shareType) {
			let shareInfo = {
				//分享网页4个参数
				// targetUrl: config.API_HOST + '/active.modal/#/share?uuid=' + this.uuid + '&userName=' + this.userName + '&gameId=' + this.gameInf.id + '&activityId=' + this.activityId, //分享链接
				targetUrl: 'http://test2500.fw.233xyx.com/active.modal/#/share?source=sg&uuid=' + this.uuid + '&userName=' + this.userName + '&gameId=' + this.gameInf.id + '&activityId=' + this.activityId, //分享链接
				title: this.userName + '预约《' + this.gameInf.displayName + '》抽奖，邀你参加', //分享标题
				desc: this.gameInf.description, //分享描述
				imgUrl: this.gameInf.iconUrl, //分享图标
				//web
				shareType: shareType, //Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
				analyticsType: 5 //233小游戏分享参数
			};
			if(primaryApi.share(shareInfo)){//调用安卓api分享
				//默认唤起Android分享成功即分享成功
				this.conditionType = 2;
				this.postConditionAward();
			}
		},
		//取背包中礼包码复制到剪切板
		clickcCopy(bagPropList) {
			for(let i = 0; i < bagPropList.length; i++) {
				if(bagPropList[i].propId = this.giftbagId){
					primaryApi.writeClipBoard(bagPropList[i].propValue); //复制礼包码到剪切板
					this.$toast('已复制到剪切板');
					break;
				}
			}
		},
		//复制并使用
		copyUse() {
			/* 再次请求背包是因为预约奖励是发放到背包，再次请求刷新才能拿到具体礼包码奖励 */
			this.getbag();
			/* 开始游戏流程 */
			this.subscribeClickBtn();
		}
	}
}
</script>
<style>
	.assemblyBgColor{
		background-color: rgba(255,255,255,0.08);
	}
</style>
<style scoped="scoped">
	.wrap{
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
	}
	.wrap::-webkit-scrollbar {display:none}
	.content{
		background-repeat: no-repeat;
		background-position: top;
		background-size: contain;
		padding-bottom: 0.7rem;
		position: relative;
	}
	.contentBg{
		position: relative;
		/* top: 0; */
		/* left: 0; */
	}
	.contentBg img{
		width: 100%;
		height: auto;
	}
	.gradientMask{
		width: 100%;
		height: 100%;
		/* background-image: linear-gradient(180deg, rgba(18,18,18,0) 0%, rgba(255,255,255,0.08) 100%); */
		background-image: linear-gradient(180deg, rgba(18,18,18,0.00) 0%, #242424 100%);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}
	.main{
		position: relative;
		z-index: 3;
	}
	.mainTop{
		text-align: center;
		padding-bottom: 0.1rem;
	}
	.mainTop img{
		width: 0.96rem;
		height: 0.96rem;
		border-radius: 0.2rem;
		margin-top: -0.5rem;
	}
	.mainTop p{
		font-size: 0.14rem;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.mainTop p.tit{
		font-size: 0.2rem;
		margin-top: 0;
		padding: 0.04rem 0;
	}
	.mainTop p.tit em{
		position: relative;
	}
	.mainTop p.tit em span{
		background-color: #00D412;
		border-radius: 0.03rem;
		font-size: 0.09rem;
		display: block;
		position: absolute;
		left: calc(100% + 0.03rem);
		top: 50%;
		width: 0.44rem;
		height: 0.2rem;
		text-align: center;
		line-height: 0.2rem;
		margin-top: -0.1rem;
		font-size: 0.12rem;
	}
	.shareWrap{
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: rgba(255,255,255,0.08);
		height: 0.6rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10;
	}
	.shareBtn{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		width: 0.4rem;
	}
	.shareBtn img{
		width: 0.24rem;
		height: 0.24rem;
	}
	.shareBtn span{
		color: rgba(255,255,255,0.87);
		font-size: 0.12rem;
	}
	.makeBtn{
		width: 2.85rem;
		height: 0.44rem;
		border-radius: 0.22rem;
		text-align: center;
		line-height: 0.44rem;
		color: #1c1c1c;
		font-size: 0.16rem;
		background-color: #FAD700;
		margin-left: 0.1rem;
		position: relative;
		overflow: hidden;
		border: none;
	}
	.noMakeBtn{
		background-color: #9D8807;
	}
	.progress, .makeBtn i{
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		height: 100%;
	}
	.makeBtn i{
		width: 100%;
		z-index: 12;
	}
	.progress{
		background: #FF9500;
		width: 0%;
		z-index: 11;
		transition: width 0.5s;
		-moz-transition: width 0.5s;	/* Firefox 4 */
		-webkit-transition: width 0.5s;	/* Safari 和 Chrome */
		-o-transition: width 0.5s; /* Opera */
	}
	.returnIcon{
		position: fixed;
		left: 0.14rem;
		top: 0.14rem;
		width: 0.28rem;
		height: 0.28rem;
		z-index: 4;
	}
	.bag{
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 0.64rem;
		height: 0.64rem;
		background-color: rgb(0, 0, 0, 0.5);
		border-radius: 50%;
	}
	.bag img{
		width: 0.4rem;
		height: 0.425rem;
	}
	.mask{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.75);
		z-index: 151;
	}
	.maskBox{
		width: 2.8rem;
		height: auto;
		background-color: #fff;
		border-radius: 0.12rem;
		padding-top: 0.17rem;
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		overflow: hidden;
	}
	.phoneTop{
		top: 1rem;
		-webkit-transform: translate(-50%, 0);
		transform: translate(-50%, 0);
	}
	.closeMask{
		text-align: right;
		font-size: 0;
		padding: 0 0.17rem;
		position: relative;
		z-index: 152;
	}
	.closeMask img{
		width: 0.16rem;
		height: 0.16rem;
	}
	.maskBox p{
		font-size: 0.14rem;
		color: #666666;
		margin-top: 0.06rem;
	}
	.maskBox p.pUnm{
		padding-left: 1.5em;
		position: relative;
	}
	.maskBox p span{
		position: absolute;
		left: 0;
		top: 0;
	}
	.bigTit{
		font-size: 0.19rem;
		color: #333333;
		text-align: center;
		font-weight: bold;
	}
	.phonBox{
		padding: 0 0.2rem 0.1rem;
	}
	.phoneInput{
		position: relative;
		margin-top: 0.18rem;
	}
	.phoneInput input{
		background-color: #F5F5F5;
		font-size: 0.15rem;
		color: #1C1C1C;
		outline: none;
		caret-color: #FF9500;
		border: none;
		width: 100%;
		padding: 0.1rem 0.32rem 0.1rem 0.16rem;
		border-radius: 0.04rem;
	}
	.phoneInput input::-webkit-input-placeholder{
		color: #999999;
	}
	.phoneInput input::input-placeholder{
		color: #999999;
	}
	.phoneInput img{
		position: absolute;
		top: 50%;
		right: 0.16rem;
		-webkit-transform: translate(0, -50%);
		transform: translate(0, -50%);
		width: 0.14rem;
		height: 0.14rem;
	}
	.phoneBtn{
		font-size: 0.15rem;
		color: #FF9500;
		border: none;
		border-top: 1px solid #EEEEEE !important;
		width: 100%;
		text-align: center;
		padding: 0.12rem 0;
	}
	.maskMessage{
		position: fixed;
		bottom: 1.2rem;
		left: 50%;
		-webkit-transform: translate(-50%, 0);
		transform: translate(-50%, 0);
		font-size: 0.14rem;
		color: #FFFFFF;
		background-color: #333333;
		height: 0.36rem;
		line-height: 0.36rem;
		padding: 0 0.2rem;
		border-radius: 0.08rem;
	}
	.sucessMain{
		padding: 0 0.2rem 0.2rem;
		text-align: center;
	}
	.makeSucessMain p{
		text-align: left;
	}
	.makeSucessMain .bigTit{
		margin-top: 0.1rem;
	}
	.ylTxt{
		font-size: 0.14rem;
		color: #FF9500;
		margin-top: 0.04rem;
	}
	.clickBtn{
		background-color: #FF9500;
		border-radius: 0.22rem;
		font-size: 0.15rem;
		color: #FFFFFF;
		height: 0.44rem;
		line-height: 0.44rem;
		margin-top: 0.2rem;
	}
	.btnBox{
		margin-top: 0.2rem;
		font-size: 0;
		text-align: center;
	}
	.btnBox .btnSpan{
		width: 1rem;
		height: 0.44rem;
		line-height: 0.44rem;
		display: inline-block;
		background-color: #FF9500;
		border-radius: 0.22rem;
		font-size: 0.15rem;
		color: #FFFFFF !important;
		margin-right: 0.15rem;
	}
	.btnBox .btnSpan:last-child{
		margin-right: 0;
	}
	.copyBox{
		height: 0.44rem;
		line-height: 0.44rem;
		font-size: 0.14rem;
		color: #333333;
		text-align: left;
		background-color: #F8F8F8;
		border-radius: 0.06rem;
		padding-left: 0.16rem;
		padding-right: 0.53rem;
		position: relative;
		margin-top: 0.25rem;
	}
	.copyBox span{
		display: block;
		width: 0.43rem;
		height: 0.28rem;
		line-height: 0.28rem;
		text-align: center;
		border-radius: 0.04rem;
		background-color: #fff;
		font-size: 0.12rem;
		color: #333333;
		position: absolute;
		right: 0.08rem;
		top: 0.08rem;
	}
	.copyMain p{
		margin-top: 0.09rem;
	}
	.prizeMain{
		text-align: center;
	}
	.prizeBox{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 0.8rem;
		height: 0.8rem;
		margin: 0 auto;
		background-color: #F5F5F5;
		border-radius: 0.08rem;
		margin-top: 0.2rem;
	}
	.prizeBox img{
		width: 0.38rem;
		height: 0.38rem;
		border-radius: 0.08rem;
	}
	.prizeMain{
		padding-bottom: 0.2rem;
	}
	.prizeMain p{
		margin-top: 0.1rem;
	}
	.prizeMain .prizeBox p{
		font-size: 0.12rem;
		color: #999999;
		margin-top: 0.03rem;
	}
	.prizeTit{
		text-align: center;
		/* margin-top: -0.5rem; */
	}
	.prizeTit img{
		width: 2.13rem;
		height: 0.54rem;
	}
	.gradient{
		background-image: linear-gradient(180deg, #FFEECC 0%, #FFFFFF 78%);
	}
	.prizeBtn{
		font-size: 0;
		margin-top: 0.3rem;
	}
	.prizeBtn span{
		width: 1.14rem;
		height: 0.44rem;
		line-height: 0.44rem;
		border-radius: 0.22rem;
		font-size: 0.15rem;
		color: #4A4A4A;
		display: inline-block;
	}
	.prizeBtn span:first-child{
		background-color: #F2F2F2;
	}
	.prizeBtn span:last-child{
		background-color: #FF9500;
		color: #fff;
		margin-left: 0.1rem;
	}
	.shareBox{
		text-align: center;
		background-color: #FFFFFF;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		border-top-left-radius: 0.12rem;
		border-top-right-radius: 0.12rem;
		padding-top: 0.1rem;
	}
	.shareBox p{
		font-size: 0.14rem;
		color: #1C1C1C;
		font-weight: bold;
	}
	.shareCon{
		display: flex;
		padding: 0 0.2rem 0.2rem;
		margin-top: 0.18rem;
	}
	.shareItem{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 25%;
	}
	.shareItem i{
		font-size: 0.13rem;
		color: #999999;
		margin-top: 0.08rem;
	}
	.closeShare{
		font-size: 0.15rem;
		color: #999999;
		height: 0.48rem;
		line-height: 0.48rem;
		background: #F8F8F8;
	}
	.maskLoading {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 999;
		background: rgba(189, 84, 28, 0.98);
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.maskLoading img {
		display: block;
		width: 0.4rem;
		height: 0.4rem;
		animation: loading 2s linear 0s infinite;
	}
	@keyframes loading {
		from {
			transform: rotate(0);
		}
	
		to {
			transform: rotate(360deg);
		}
	}
</style>
